const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Riverlea",

  webfeedDebuggerWebsiteUrl:
    "https://www.riverlea.com.au/for-sale/#/masterplan",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
